import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'

export class Language extends Component {
    static displayName = Language.name;
    state = {
        showModal: false,

        state:"1",

      
    };


    componentDidMount() {

    }

    handleInputChange = (event) => {
        const target = event.target;
        //const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value;
        const value = target.value;

        const name = target.name;
        this.setState({ [name]: value, setRadio: 1 }, console.log('stte', this.state));
    };

    render() {

        return (
            <>
                <CustomModal show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="row">
                        <div className="col">
                            <div className="d-flex">
                                انتخاب زبان
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="d-flex">
                                <div className="p-2 flex-fill">فارسی</div>
                                <div className="p-2">
                                    <input type="radio" name="state" value="1" onChange={this.handleInputChange} checked={this.state.state == "1"} />
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="p-2 flex-fill">English</div>
                                <div className="p-2">
                                    <input type="radio" name="state" value="2" onChange={this.handleInputChange} checked={this.state.state == "2"} />
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="p-2 flex-fill">العربیه</div>
                                <div className="p-2">
                                    <input type="radio" name="state" value="3" onChange={this.handleInputChange} checked={this.state.state == "3"} />
                                </div>
                            </div>
                            <div className="d-flex p-2" >
                                <div className="p-2 flex-fill"></div>
                                <div className="p-2">
                                    <button className="btn btn-dark" onClick={(e) => {  this.props.closeModal(e) }}>انتخاب</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>

        );
    }


}